import { ContextNavigate } from '../shared/components/context-navigate/context-navigate';

import { BudgetLimits } from './containers/budget-limits/budget-limits';
import { SelfExclusion } from './containers/self-exclusion/self-exclusion';
import { SessionLimitsContinuous } from './containers/session-limits-continuous/session-limits-continuous';
import { SessionLimitsCumulatives } from './containers/session-limits-cumulative/session-limits-cumulative';
import { UserBudgetLimitMediatorTypeView } from './limits.interface';

export default [
    {
        path: 'casino-budget-limits',
        element: <BudgetLimits mediatorType={UserBudgetLimitMediatorTypeView.CASINO} />,
    },
    {
        path: 'sports-budget-limits',
        element: <BudgetLimits mediatorType={UserBudgetLimitMediatorTypeView.SPORTS} />,
    },
    {
        path: 'deposit-budget-limits',
        element: <BudgetLimits mediatorType={UserBudgetLimitMediatorTypeView.DEPOSIT} />,
    },
    {
        path: 'session-limits-continuous',
        element: <SessionLimitsContinuous />,
    },
    {
        path: 'session-limits-cumulative',
        element: <SessionLimitsCumulatives />,
    },
    {
        path: 'self-exclusion',
        element: <SelfExclusion />,
    },
    {
        path: '*',
        index: true,
        element: <ContextNavigate to="/account/responsible-gaming/casino-budget-limits" replace />,
    },
];
